<header class="bank__header">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="bank__select-class">
          <div
            *ngFor="let tc of teacherClasses"
            class="bank__class"
            (click)="goToClassAccount(tc)">
            <div class="bank__class__school-title">
              <img
                *ngIf="tc.school.logo; else noLogo;"
                [src]="tc.school.logo"
                [alt]="tc.school.title"
                class="bank__class__school-logo">
              <ng-template #noLogo>
                <span>Шк. <b>{{tc.school.title | shorten }}</b></span>
              </ng-template>
            </div>
            <div class="divider">|</div>
            <div class="bank__class__class-title">
              <span><b>{{tc.title}}</b> класс</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
